import { createSelector } from 'reselect';
import { extractTokenPayload } from 'utils/token';

/**
 * @return {number}
 */
export const userIdSelector = createSelector(
  () => extractTokenPayload(),
  (token) => {
    return token ? token.user_id : null;
  }
);
